import React from 'react';
import styled from 'styled-components';
import LoadingOverlay from '@speedy4all/react-loading-overlay';
import * as R from 'ramda';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const LoadingStyle = styled(LoadingOverlay)`
  position: fixed;
  margin: auto;
  align: middle;
  width: 100%;
  verticalAlign: middle;
  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.03);
  }
`;

export const Spinner = () => (
    <img alt="Tao of Healthpoint" src="/hp-spinner.gif"/>
);
export const Loading = () => (
    <LoadingStyle
        className="d-flex justify-content-center"
        active={true}
        classNamePrefix='MyLoader_'
        spinner = {<Spinner/>}
    >
        <div style={{height:"50vh"}}>
            <p className={"p-4"}>Loading ...</p>
        </div>
    </LoadingStyle>
);

const whileLoading = isLoading => {
    const userSession = useSelector(state => state.cognito.userSession);

    return Right => {
        if (R.isEmpty(userSession)) {
            // TODO: We should actually check if the browser has cookies that
            // allow us to set up the `userSession`.
            return <Navigate to="/login" />
        } else if (isLoading) {
            return <Loading />
        } else {
            return Right
        }
    }
};

export default whileLoading;
